module.exports = {"id":"227690","name":"Dmitriy Stotskiy","rating":"73","photo":"./data/images/photos/2/227690.png","club":{"name":"FK Oufa","logo":"./data/images/clubs/FKOufa.png"},"positions":["DLG","MC","ATT","DLD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DmitriyStotskiy0.json
// module id = 1121
// module chunks = 0